<script>
import {Bar, mixins} from 'vue-chartjs'
import Chart from 'chart.js'
const { reactiveProp } = mixins

let rectangleSet = false
let showTickIndex = 0

let showZeroPlugin = {
  beforeRender: function (chartInstance) {
    let datasets = chartInstance.config.data.datasets
    let data = []

    if(datasets.length !== 0) {
      // 다 그려지기 전에(dataset이 빈 배열일 경우에도)실행 되는 일이 있기 때문에 길이 체크
      for (var i = 0; i < datasets[0].data.length; i++) {
        data.push(0)
      }
    }
    // eslint-disable-next-line no-redeclare
    for (var i = 0; i < datasets.length; i++) {
      let meta = datasets[i]._meta
      for (var k = 0; k < datasets[i].data.length; k++) {
        data[k] += datasets[i].data[k]
      }

      // It counts up every time you change something on the chart so
      // this is a way to get the info on whichever index it's at
      let metaData = meta[Object.keys(meta)[0]]
      let bars = metaData.data

      for (let j = 0; j < bars.length; j++) {
        let model = bars[j]._model

        if(i === datasets.length - 1 && data[j] === 0) {
          // 마지막 라벨이고 data[j]가 0 일 경우 (남성, 여성, 성별모름의 합산데이터가 0일 경우)
          if (metaData.type === 'horizontalBar' && model.base === model.x) {
            model.borderColor = 'rgba(0,0,0,0.1)'
            model.backgroundColor = '#D9F0FF'
            model.x = model.base + 10
          } else if (model.base === model.y) {
            model.backgroundColor = '#D9F0FF'
            model.y = model.base - 10
          }
        }
      }
    }
  }
}

Chart.pluginService.register(showZeroPlugin)


export default {
  extends: Bar,
  mixins: [reactiveProp],
  data () {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            label: (tooltipItems, data) => {
              let index = tooltipItems.datasetIndex
              return data.datasets[index].label + ': ' + tooltipItems.yLabel + '만원'
            }
          }
        },
        scales: {
          xAxes: [{
            stacked: true,
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              autoSkip: false,
              beginAtZero: true,
              min: 0,
              precision: 0,
              stepSize: 1,
              suggestedMax: 50,
              callback: function (value, index, values) {
                if(index === 0) {
                  // 배열의 첫번째일시 처리
                  showTickIndex = 0
                }
                let interval = Math.floor(values.length / 5)
                if(interval === 0) {
                  return value
                }
                if((index === showTickIndex || index === values.length - 1) && (value !== 1 && value !== 2 && value !== 3 && value !== 4)) {
                  // 첫값과 마지막값은 무조건 보여줌
                  // 0에 딱 붙는값들( value === 1, 2, 3, 4) 안나오게 처리
                  showTickIndex += interval
                  return value
                }
              }
            }
          }]
        },
        animation: {
          onComplete: function () {
            if (!rectangleSet) {
              var scale = window.devicePixelRatio
              var sourceCanvas = this.chart.canvas
              var copyWidth = this.scales['y-axis-0'].width - 10
              var copyHeight = this.scales['y-axis-0'].height + this.scales['y-axis-0'].top + 10

              var targetCtx = document.getElementById('axis-Test3').getContext('2d')

              targetCtx.scale(scale, scale)
              targetCtx.canvas.width = copyWidth * scale
              targetCtx.canvas.height = copyHeight * scale

              targetCtx.canvas.style.width = copyWidth + 'px'
              targetCtx.canvas.style.height = copyHeight + 'px'
              targetCtx.drawImage(sourceCanvas, 0, 0, copyWidth * scale, copyHeight * scale, -5, 0, copyWidth * scale, copyHeight * scale)

              var sourceCtx = sourceCanvas.getContext('2d')

              // Normalize coordinate system to use css pixels.

              sourceCtx.clearRect(0, 0, copyWidth * scale, copyHeight * scale)
            }
          },
          onProgress: function () {
            if (rectangleSet === true) {
              var copyWidth = this.scales['y-axis-0'].width
              var copyHeight = this.scales['y-axis-0'].height + this.scales['y-axis-0'].top + 10

              var sourceCtx = this.chart.canvas.getContext('2d')
              sourceCtx.clearRect(0, 0, copyWidth, copyHeight)
            }
          }
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/board/elements/adFeeBarChart.vue